export default __webpack_public_path__ + "0add21eaf7862cacb35d5ff023eeba47.png";